import { useContext, useEffect, useState } from 'react'
import HistoryContext from '../../context/HistoryContext'
import CatalogInterface, { CatalogListItemInterface } from '../../interfaces/CatalogInterface'
import { ActiveFiltersInterface, ProductFiltersInterface } from '../../interfaces/FiltersInterface'
import PagerInterface from '../../interfaces/PagerInterface'
import * as clubApi from '../../services/club/club.api'
import { buildQueryParams, getFlatFilters, groupSizeFilter, loadFiltersFromQueryParams } from '../../utils/productFilter'
import useSearch from '../search/search'

const UPDATE_DELAY = 150
const RESULTS_PER_PAGE = 12

export const useClubOffers = () => {
  const [items, setItems] = useState<CatalogListItemInterface[]>([])
  const [filters, setFilters] = useState<ProductFiltersInterface>()
  const [activeFilters, setActiveFilters] = useState<ActiveFiltersInterface>({} as ActiveFiltersInterface)
  const [filtersQueryString, setFiltersQueryString] = useState<string>()
  const [pager, setPager] = useState<PagerInterface>()

  const { transformProducts } = useSearch()
  const history = useContext(HistoryContext)
  const location = history.location

  let timer: NodeJS.Timeout | null = null
  let axiosAbortController: AbortController | null = null

  useEffect(() => {
    setActiveFilters(loadFiltersFromQueryParams(location.search))
  }, [])

  useEffect(() => {
    setActiveFilters(loadFiltersFromQueryParams(location.search))
    setFiltersQueryString(location.search)
  }, [location.search])

  const fetchData = async (page: number, perPage: number = RESULTS_PER_PAGE, fetchAllPages: boolean = false) => {
    const flatFilters = getFlatFilters(filtersQueryString || location.search)
    axiosAbortController?.abort()
    axiosAbortController = new AbortController()
    return clubApi.searchFilteredOffers(page, flatFilters, perPage, fetchAllPages, axiosAbortController.signal)
  }

  const fetchCallback = (data: CatalogInterface) => {
    setFilters(groupSizeFilter(data.filters))
    setItems(data.items)
    setPager(data.pager)
  }

  const updateQueryString = (newFilters: ActiveFiltersInterface, delay: number = UPDATE_DELAY) => {
    const newQueryString = buildQueryParams(newFilters)
    if (location.search !== newQueryString) {
      if (timer != null) {
        clearTimeout(timer)
        timer = null
      }
      timer = setTimeout(() => {
        timer = null
        history.replace({
          pathname: location.pathname,
          search: newQueryString,
        })

        setFiltersQueryString(newQueryString)
      }, delay)
    }
  }

  return {
    updateQueryString,
    fetchData,
    dataTransformer: transformProducts,
    fetchCallback,
    items,
    filters,
    activeFilters,
    areFiltersVisible: filters !== null && items && items.length >= 0,
    filtersQueryString,
    itemsCounter: pager?.itemCount || 0,
  }
}
